module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u_support-c96a542852ed034df91938f8d82952df.svg";